import { type CardDescription, COINS, CUPS, MAJOR_ARCANA, SWORDS, WANDS } from './descriptions';

export type TarotCard = CardDescription & {
  image: string;
};

const CARD_BACK_COUNT = 7;

function getImageUrl(filename: string): string {
  return new URL(`./images/${filename}`, import.meta.url).href;
}

function padNumber(value: number): string {
  return String(value).padStart(2, '0');
}

/**
 * Image filename convention under `./images/`:
 *  - Major Arcana: `<NN>-<id>.png`      e.g. `00-the-fool.png`
 *  - Minor Arcana: `<suit>-<NN>.png`    e.g. `cups-01.png` (ace) … `cups-14.png` (king)
 */
export function getCardImageFilename(card: CardDescription): string {
  return card.arcana === 'major'
    ? `${padNumber(card.number)}-${card.id}.png`
    : `${card.suit}-${padNumber(card.number)}.png`;
}

// Variations of the card back, sourced from the billowwalker/Tarot-cards deck.
export const CARD_BACKS: readonly string[] = Array.from({ length: CARD_BACK_COUNT }, (_, i) =>
  getImageUrl(`back${i + 1}.png`),
);

export function getRandomCardBack(random: () => number = Math.random): string {
  return CARD_BACKS[Math.floor(random() * CARD_BACKS.length)];
}

export const TAROT_DECK: readonly TarotCard[] = [
  ...MAJOR_ARCANA,
  ...CUPS,
  ...SWORDS,
  ...COINS,
  ...WANDS,
].map((card) => ({ ...card, image: getImageUrl(getCardImageFilename(card)) }));

export type {
  Arcana,
  CardDescription,
  CardSuit,
  MajorArcanaCard,
  MinorArcanaCard,
} from './descriptions';
